import React from "react";
import { useSelector } from "react-redux";
import CustomCard from "../../../../components/customCard/index";
import Error from "../../../../components/Error/index";
import Spinner from "../../../../components/presentationals/Spinner";
import { lmtdCheck, getJCJPIDs } from "../../../../utils/common/index";

const ActivationSalesDistributionTabsView = ({
  url,
  csvEndPointUrl,
  isCsvActive,
  filterValue,
  headerSelectedDateFrom,
  headerSelectedDateTo,
  fetchCsvData,
  section,
  moduleName,
}) => {
  const { distributionObj, actCsvLoading } = useSelector(
    (state) => state.activationSalesReducer
  );

  const endpointData = distributionObj && distributionObj.distributionTableData;
  const tableContainedData =
    endpointData && endpointData[url] && endpointData[url][0];

  let { partnerRT } = getJCJPIDs(filterValue);

  return (
    <>
      {distributionObj.loading ? (
        <Spinner />
      ) : tableContainedData ? (
        <>
          <div className="d-block d-sm-none col-12">
            <div
              id="carousel-div1"
              className="carousel slide"
              data-bs-ride="carousel"
            >
              <div className="carousel-indicators">
                <button
                  type="button"
                  data-bs-target="#carousel-div1"
                  data-bs-slide-to="0"
                  className="active"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carousel-div1"
                  data-bs-slide-to="1"
                ></button>
                <button
                  type="button"
                  data-bs-target="#carousel-div1"
                  data-bs-slide-to="2"
                ></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <CustomCard
                    tileName={
                      partnerRT === "ARD" || partnerRT === "MARD"
                        ? "Retailer Billed(UAO+URO)"
                        : "Billed"
                    }
                    csvName="Billed"
                    lmtd={
                      lmtdCheck(headerSelectedDateFrom, headerSelectedDateTo)
                        ? tableContainedData.billedLMTD
                        : ""
                    }
                    value={tableContainedData.billed}
                    csv={csvEndPointUrl}
                    csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                    gradient="1"
                    loading={actCsvLoading}
                    dashboardName={moduleName}
                    viewName={section}
                  />
                </div>
                <div className="carousel-item">
                  <CustomCard
                    tileName={
                      partnerRT === "ARD" || partnerRT === "MARD"
                        ? "Total Retailers On-Boarded"
                        : "On Boarded"
                    }
                    csvName="On Boarded"
                    value={tableContainedData.onBoarded}
                    csv={csvEndPointUrl}
                    csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                    gradient="2"
                    loading={actCsvLoading}
                    dashboardName={moduleName}
                    viewName={section}
                  />
                </div>
                <div className="carousel-item">
                  <CustomCard
                    tileName="Percentage Billed"
                    value={tableContainedData.percentageBilled}
                    percentage={true}
                    gradient="3"
                    loading={actCsvLoading}
                    dashboardName={moduleName}
                    viewName={section}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="d-none d-sm-block col-12">
            <div className="row">
              <CustomCard
                tileName={
                  partnerRT === "ARD" || partnerRT === "MARD"
                    ? "Retailer Billed(UAO+URO)"
                    : "Billed"
                }
                csvName="Billed"
                lmtd={
                  lmtdCheck(headerSelectedDateFrom, headerSelectedDateTo)
                    ? tableContainedData.billedLMTD
                    : ""
                }
                value={tableContainedData.billed}
                csv={csvEndPointUrl}
                csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                gradient="1"
                loading={actCsvLoading}
                dashboardName={moduleName}
                viewName={section}
              />
              <CustomCard
                tileName={
                  partnerRT === "ARD" || partnerRT === "MARD"
                    ? "Total Retailers On-Boarded"
                    : "On Boarded"
                }
                csvName="On Boarded"
                value={tableContainedData.onBoarded}
                csv={csvEndPointUrl}
                csvDownload={isCsvActive === "Y" ? fetchCsvData : ""}
                gradient="2"
                loading={actCsvLoading}
                dashboardName={moduleName}
                viewName={section}
              />
              <CustomCard
                tileName="Percentage Billed"
                value={tableContainedData.percentageBilled}
                percentage={true}
                gradient="3"
                loading={actCsvLoading}
                dashboardName={moduleName}
                viewName={section}
              />
            </div>
          </div>
        </>
      ) : (
        <Error error={distributionObj.error} />
      )}
    </>
  );
};

export default ActivationSalesDistributionTabsView;
